var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.appInfoNew.domainSubject)?_c('el-footer',{staticClass:"el-footer-wrap",attrs:{"height":"32px"}},[_c('p',[_vm._v("系统建设方："+_vm._s(_vm.appInfoNew.domainSubject))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }